import moment from 'moment';

export function SCAdminTodo(data){
    var self = this;
    self.type = "SCAdminTodo";

    self.rootvm = data.rootvm;

    self.todo_uuid = ko.observable(data.todo_uuid);

    self.priority = ko.observable(data.priority);
    self.todo_type = ko.observable(data.todo_type);

    self.todo_inviter_person_uuid = ko.observable(data.todo_inviter_person_uuid);
    self.todo_event_uuid = ko.observable(data.todo_event_uuid);

    self.effective_lower = ko.observable();
    self.effective_upper = ko.observable();

    if(data.effective && typeof data.effective === 'string'){
        // parse effective into lower and upper parts
        const better_effective = JSON.parse(data.effective.replace(')', ']').replace('infinity', '"infinity"'));
        self.effective_lower(better_effective[0]);
        // console.log("upper is ", better_effective[1]);

        if(better_effective[1] !== 'infinity'){
            self.effective_upper(better_effective[1]);
        }
    }
    else if(data.effective && typeof(data.effective) == 'object'){
        self.effective_lower(data.effective.lower);

        if(data.effective.upper.indexOf('9999') !== 0){
            self.effective_upper(data.effective.upper);
        }

    }
    self.due_date = ko.observable(data.due_date);
    self.completed_date = ko.observable(data.completed_date);

    self.due_date_pretty = ko.pureComputed(function(){
        if(self.due_date()){
            return new moment(self.due_date()).format('DD.MM.YYYY');
        }
    });

    self.completed_date_pretty = ko.pureComputed(function(){
        if(self.complete()){
            return new moment(self.effective_upper()).format('DD.MM.YYYY');
        }
    });



    self.assigned_to = ko.observable(data.assigned_to);

    self.open_comment = ko.observable(data.open_comment);
    self.open_action = ko.observable(data.open_action);
    self.close_comment = ko.observable(data.close_comment);
    self.close_action = ko.observable(data.close_action);

    self.opened_by = data.opened_by;
    self.closed_by = data.closed_by;


    self.in_progress = ko.pureComputed(function(){
        return self.effective_lower() !== undefined && self.effective_upper() === undefined;
    });

    self.complete = ko.pureComputed(function(){
        return self.effective_lower() !== undefined && self.effective_upper() !== undefined;
    });

    self.closed_date_pretty = ko.pureComputed(function(){
        if(self.complete() && self.effective_upper() !== undefined){
            return new moment(self.effective_upper()).format('DD.MM.YYYY');
        }
    });

    self.assigned_to_me = ko.pureComputed(function(){
        if(self.rootvm !== undefined){
            return self.assigned_to() == self.rootvm.user_logged_in();
        }
    });


    self.badge_class = ko.pureComputed(function(){
        if(self.effective_upper() !== undefined){
            return 'bg-success bg-opacity-25 text-black text-opacity-75';
        }
        else{
            if(!self.assigned_to_me()){
                return 'bg-secondary bg-opacity-25 text-black text-opacity-50';
            }
            else{
                return 'bg-info bg-opacity-50 text-white';

            }
        }
    });

    self.assigned_user_pretty = ko.observable(data.assigned_user_pretty);

    self.assigned_user_short = ko.pureComputed(function(){
        return self.assigned_user_pretty();
    });

    self.reset = function(){
        self.priority(undefined);
        self.todo_type(undefined);
        self.todo_inviter_person_uuid(undefined);
        self.effective_lower(undefined);
        self.effective_upper(undefined);
        //self.due_date(undefined);
        self.assigned_to(undefined);
        self.open_comment(undefined);
        self.close_comment(undefined);
        self.open_action(undefined);
        self.close_action(undefined);
    }
}
